
/** @format */

import React, { type Ref } from 'react'
import { Button } from 'antd'

const cx = (...classes: any[]) => classes.filter(Boolean).join(' ')

const getColor = (status: string) => {
  let st = status?.toLowerCase()
  switch (st) {
    case 'good':
      return '#00CC0E'
    case 'warning':
      return '#FFC000'
    case 'expired':
      return '#ff0000'
  }
}

const ContainerBase = ({ className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'flex w-full items-center justify-between',
      className
    )}
    style={style}
    {...props}
  >
    {children}
  </div>
)
ContainerBase.displayName = 'ContainerBase'

const ContainerFlex = ({ className, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div ref={ref} className={cx('flex items-center gap-4 text-xs font-semibold text-[#212121]', className)} {...props}>
    {children}
  </div>
)
ContainerFlex.displayName = 'ContainerFlex'

const ContainerTitle = ({ status, className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx('font-normal text-[10px] leading-4 ml-2.5 w-fit', className)}
    style={{
      color: status ? getColor(status) : undefined,
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
)
ContainerTitle.displayName = 'ContainerTitle'

export const Container = Object.assign(ContainerBase, {
  Flex: ContainerFlex,
  Title: ContainerTitle,
})

export const WrapperTr = ({ className, style, children, ref, ...props }: any & { ref?: Ref<any> }) => (
  <div
    ref={ref}
    className={cx(
      'py-px px-0',
      '[&_#selectWrapper]:min-w-[200px] [&_#selectWrapper]:mx-auto [&_#selectWrapper_span]:text-[rgba(68,68,68,0.66)]',
      '[&_.iconsWrapper]:flex [&_.iconsWrapper]:justify-end [&_.iconsWrapper]:items-center [&_.iconsWrapper_div]:max-w-fit',
      className
    )}
    style={style}
    {...props}
  >
    {children}
  </div>
)
WrapperTr.displayName = 'WrapperTr'

export const StButton = ({ hoverColor, className, style, ref, ...props }: any & { ref?: Ref<any> }) => (
  <Button
    ref={ref}
    className={cx('flex items-center gap-2.5 !bg-[#1a1c3b] !text-white !border-none !rounded-none !h-8 !px-6 !text-sm !font-medium', className)}
    style={{
      '--hover-color': hoverColor,
      ...style,
    }}
    {...props}
  />
)
StButton.displayName = 'StButton'
